export default __webpack_public_path__ + "static/media/firepost.0430fe5a.png";